import React from 'react'

// react router
import { Link } from 'react-router-dom';

// icons : feather
import FeatherIcon from 'feather-icons-react';

// images
import noImgFound from 'assets/images/no-img-found.png'
import useStoreUrl from 'utlis/CustomHooks/useStoreUrl';


export default function ProductsView(props) {
    // props
    const { orderDetails } = props

    // store url
    const [storeUrl] = useStoreUrl()

    return (
        <React.Fragment>
            {/* page border box */}
            <div className="page-border-box mb-3">
                <div className="pbb-inner">
                    <p className="head st-fw-600 st-text-color2 st-fs-16 mb-3">Order items: <span>1</span></p>

                    <div className="products-view">
                        {/* product view */}
                        <div className="product-view-table">
                            <div className="table-responsive">
                                <table className="table mb-0">
                                    <thead>
                                        <tr>
                                            <th colSpan={2}>
                                                Product Details
                                            </th>
                                            <th className="text-end">
                                                SKU
                                            </th>
                                            <th className="text-end">
                                                Price
                                            </th>
                                            <th className="text-end">
                                                Qty
                                            </th>
                                            <th className="text-end">
                                                Subtotal
                                            </th>
                                        </tr>
                                    </thead>

                                    <tbody>
                                        {
                                            orderDetails?.orderItems?.length && orderDetails.orderItems.map(item => (
                                                <tr key={item.order_item_id}>
                                                    <td width={60}>
                                                        <div className="img-sec" style={{ width: 60 }}>
                                                            <img
                                                                src={orderDetails?.images[item.order_item_id] || noImgFound}
                                                                alt=""
                                                                className="img-fluid img-fluid-height"
                                                                onLoad={ev => ev.target.parentNode.classList.add("loaded")}
                                                            />
                                                        </div>
                                                    </td>
                                                    <td>
                                                        <Link
                                                            to={`${storeUrl}/catalog/products/edit/${item.product_id}`}
                                                            target="_blank"
                                                            rel="noreferrer"
                                                            className="prod-heading-in-table st-fs-18 mb-2 st-text-color st-fw-600 text-decoration-none d-inline-block">
                                                            {item.product_name}
                                                        </Link>
                                                        <p className="prod-details-in-table st-text-color2">
                                                            <span className="me-2">
                                                                {item.variant_name}
                                                            </span>
                                                        </p>
                                                    </td>
                                                    <td width={100}>
                                                        <p className="prod-heading-in-table st-fs-18 mb-2 st-text-color st-fw-600 text-end">
                                                            {item.sku}
                                                        </p>
                                                    </td>
                                                    <td width={150}>
                                                        <p className="prod-heading-in-table st-fs-18 mb-2 st-text-color st-fw-600 text-end">
                                                            {item.currency_price}
                                                        </p>
                                                    </td>
                                                    <td width={130}>
                                                        <p className="prod-heading-in-table st-fs-18 mb-2 st-text-color st-fw-600 text-end">
                                                            {item.quantity}
                                                        </p>
                                                    </td>
                                                    <td width={130}>
                                                        <p className="prod-heading-in-table st-fs-18 mb-2 st-text-color st-fw-600 text-end">
                                                            {item.current_total_price}
                                                        </p>
                                                    </td>
                                                </tr>
                                            ))
                                        }
                                    </tbody>

                                    <tfoot>
                                        <tr>
                                            <td colSpan={5} className="border-top">
                                                <p className="prod-heading-in-table st-fs-17 st-text-color text-end">
                                                    Items:
                                                </p>
                                            </td>
                                            <td className="border-top">
                                                <p className="prod-heading-in-table st-fs-17 st-text-color st-fw-600 text-end">
                                                    {orderDetails?.orders?.currency_sub_total}
                                                </p>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td colSpan={5} className="">
                                                <p className="prod-heading-in-table st-fs-17 st-text-color text-end">
                                                    Discount:
                                                </p>
                                            </td>
                                            <td className="">
                                                <div className="d-flex align-items-center justify-content-end">
                                                    {
                                                        orderDetails?.orders?.coupon_code ? ( // if some coupon code is applied by the user
                                                            <div className="discount-info position-relative ms-2">
                                                                <p className="text-head text-danger prod-heading-in-table st-fs-17 st-text-color st-fw-600 text-end">
                                                                    {orderDetails?.orders?.currency_promo_discount}
                                                                </p>
                                                                <div className="content position-absolute">
                                                                    <div className="inner">
                                                                        <p className="mb-0">
                                                                            {orderDetails?.orders?.currency_promo_discount} ({orderDetails?.orders?.coupon_discount_with_type}) for
                                                                            applied coupon
                                                                            <span className="d-block st-fw-600">
                                                                                '{orderDetails?.orders?.coupon_code}'
                                                                            </span>
                                                                        </p>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        ) : (
                                                            <p className="text-danger prod-heading-in-table st-fs-17 st-text-color st-fw-600 text-end">
                                                                {orderDetails?.orders?.currency_promo_discount}
                                                            </p>
                                                        )
                                                    }
                                                </div>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td colSpan={5} className="">
                                                <p className="prod-heading-in-table st-fs-17 st-text-color text-end">
                                                    Shipping:
                                                </p>
                                            </td>
                                            <td className="">
                                                <p className="prod-heading-in-table st-fs-17 st-text-color st-fw-600 text-end">
                                                    {orderDetails?.orders?.currency_shipping}
                                                </p>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td colSpan={5} className="">
                                                <p className="prod-heading-in-table st-fs-17 st-text-color text-end">
                                                    Tax:
                                                </p>
                                            </td>
                                            <td className="">
                                                <p className="prod-heading-in-table st-fs-17 st-text-color st-fw-600 text-end">
                                                    {orderDetails?.orders?.currency_tax ?? "$0.00"}
                                                </p>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td colSpan={5} className="">
                                                <p className="prod-heading-in-table st-fs-19 st-fw-600 st-text-color text-end">
                                                    Total:
                                                </p>
                                            </td>
                                            <td className="">
                                                <p className="prod-heading-in-table st-fs-19 st-text-color st-fw-600 text-end">
                                                    {orderDetails?.orders?.currency_order_amount}
                                                </p>
                                            </td>
                                        </tr>
                                    </tfoot>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </React.Fragment>
    )
}
